import { useEffect, useRef } from 'react';

export default function usePrevious<T>(value: T): T {
  const ref = useRef<T>(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  // Returns the value from the previous render (the effect above runs after render)
  // eslint-disable-next-line react-hooks/refs
  return ref.current;
}
